import { editSearchEngineListing } from '../seo';
import { replaceOperation } from '../../product/operations';
import { getOversetValue } from '../../product/checkAttribute';

import { OPERATIONS, OVERSET, VALUE } from '../../../constants/product';
import { ATTRIBUTE } from '../../../constants/attributes';
import { SHOPIFY } from '../../../constants/channels';
import { EMPTY } from '../../../constants';

export function seo({ operation, product, ...rest }) {
  const operationType = operation.get('type');

  switch (operationType) {
    case OPERATIONS[SHOPIFY].META_DESCRIPTION: {
      const value = operation.get('value');
      const overset = value === getOversetValue({ attribute: ATTRIBUTE.META_DESCRIPTION, product });
      const updates = editSearchEngineListing({
        product,
        [ATTRIBUTE.META_DESCRIPTION]: {
          [OVERSET]: overset,
          [VALUE]: value,
        },
      });

      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case OPERATIONS[SHOPIFY].PAGE_TITLE: {
      const value = operation.get('value');
      const overset = value === getOversetValue({ attribute: ATTRIBUTE.PAGE_TITLE, product });
      const updates = editSearchEngineListing({
        product,
        [ATTRIBUTE.PAGE_TITLE]: {
          [OVERSET]: overset,
          [VALUE]: value,
        },
      });

      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    default: {
      return { product, ...rest };
    }
  }
}
